import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function AllChinaBuyLegit() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="pt-20 pb-4 bg-white border-b border-stone-100">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">{t('breadcrumb_home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-stone-900 font-medium">Is AllChinaBuy Legit?</span>
          </nav>
        </div>
      </div>
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-8 md:py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 shadow-sm">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-stone-100 rounded-full text-stone-600 mb-4">7 min read</span>
            <h1 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">Is AllChinaBuy Legit? Safety, Reviews &amp; Buying Guide</h1>
            <div className="flex items-center gap-4 text-sm text-stone-500 mb-6">
              <span>{t('article_last_updated')}: August 25, 2026</span>
              <span>{t('article_author')}: AllChinaBuy Research Team</span>
            </div>

            <p className="text-stone-600 leading-relaxed mb-4">
              The question <strong>"Is AllChinaBuy legit?"</strong> is one of the most searched queries about this shopping agent. This safety guide examines the platform's trustworthiness and provides practical tips for safe international shopping.
            </p>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Safety Measures in Place</h2>
            <p className="text-stone-600 leading-relaxed mb-4">AllChinaBuy implements several security features:</p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-shield-check-line text-emerald-500 mt-1"></i><span>Encrypted payment processing</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-shield-check-line text-emerald-500 mt-1"></i><span>Warehouse quality inspection (QC)</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-shield-check-line text-emerald-500 mt-1"></i><span>Package consolidation and tracking</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-shield-check-line text-emerald-500 mt-1"></i><span>Buyer protection policies</span></li>
            </ul>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Best Practices for Safe Shopping</h2>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-4">
              <div className="flex items-start gap-3">
                <i className="ri-lightbulb-line text-amber-500 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-semibold text-amber-900 mb-1">Pro Tips</h4>
                  <ul className="text-sm text-amber-800 space-y-1">
                    <li>Always use QC photos for expensive items</li>
                    <li>Research seller ratings before purchasing</li>
                    <li>Keep orders under your country's tax threshold</li>
                    <li>Use tracked shipping for valuable packages</li>
                    <li>Save all order confirmations and receipts</li>
                  </ul>
                </div>
              </div>
            </div>

            <p className="text-stone-600 leading-relaxed mb-4">
              While AllChinaBuy is a legitimate shopping agent service, all international online shopping carries inherent risks. The platform's safety features help mitigate these risks, but informed shopping practices remain your best protection.
            </p>

            <div className="mt-8 bg-stone-900 rounded-xl p-6 text-center">
              <p className="text-white mb-4">Shop safely with AllChinaBuy Spreadsheet</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-stone-900 rounded-lg text-sm font-medium hover:bg-stone-100 transition-colors cursor-pointer">
                AllChinaBuy Spreadsheet <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}